import { Dialog } from "@mui/material";
import React from "react";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import {
  getRequesterDetails,
  rejectionDialogList,
  subHeadingStyle,
} from "./constant";

const ConfirmApprovalDialog = ({
  isOpen,
  setOpen,
  approvalDetail,
  statusHandler,
  status = "APPROVE",
  title = "Approve EPMR cancellation request",
}) => {
  const closeDialog = () => {
    setOpen(false);
  };
  return (
    <Dialog open={isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <div style={{minWidth:'80%'}}>
            <div className="header">{title}</div>
            <div style={subHeadingStyle}>
              Please check the details before confirming.
            </div>
            <div className="d-flex justify-content-between mt-4">
              {getRequesterDetails(rejectionDialogList, approvalDetail)}
            </div>
          </div>
          <CrossIcon onClick={closeDialog} />
        </div>
        <div className="mt-4">
          <button className="no-ml-btn" onClick={closeDialog}>
            Go back
          </button>
          <AButton
            variant="primary_filled"
            onClick={() => {
              statusHandler(approvalDetail, "", status);
            }}
          >
            Approve
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};
export default ConfirmApprovalDialog;
